module.exports = __webpack_public_path__ + "img/dnp-a-year-in-retrospect.6b7a2007.png";